$(document).ready(function($) {
  $('.progress-container').each(function() {
    var value;
    value = $(this).children('progress').attr('value');
    $(this).children('.value').html(value).css('right', ((10 - value) * 10) + '%');
  });

  $('#scroll-content-container').css('min-height', $('#fixed-content-container').height());
  $('.pricing-toggle').click(function() {
    $('.pricing-toggle > i').toggleClass("fa-chevron-right fa-chevron-left");
    return $('.price-panel').toggleClass("collapse expand");
  });

  $('select#unit_type').on('change', function() {
    $('.length-fields').toggle();
  });
});